import { Companion_getInstance1tv6fqjnytc8u as Companion_getInstance } from '../type/GraphQLBoolean.mjs';
import {
  Builder320ghmibyd2no as Builder,
  Builder3t31vflw4km89 as Builder_0,
  CompiledVariablecaz6ndkw7us2 as CompiledVariable,
} from '../../../../../../../apollo-kotlin-apollo-api/com/apollographql/apollo/api/CompiledGraphQL.mjs';
import { Companion_getInstanceoymipm3rjnhd as Companion_getInstance_0 } from '../type/Mutation.mjs';
import { listOfvhqybd2zx248 as listOf } from '../../../../../../../kotlin-kotlin-stdlib/kotlin/collections/collectionJs.mjs';
import { initMetadataForObject1cxne3s9w65el as initMetadataForObject } from '../../../../../../../kotlin-kotlin-stdlib/kotlin/js/metadataUtils.mjs';
import { VOID3gxj6tk5isa35 as VOID } from '../../../../../../../kotlin-kotlin-stdlib/kotlin/js/void.mjs';
//region block: imports
//endregion
//region block: pre-declaration
//endregion
var SaveSlackIntegrationMutationSelectionsClass;
function SaveSlackIntegrationMutationSelections() {
  if (SaveSlackIntegrationMutationSelectionsClass === VOID) {
    class $ {
      constructor() {
        SaveSlackIntegrationMutationSelections_instance = this;
        this.d6l_1 = listOf((new (Builder())('saveSlackIntegration', Companion_getInstance().p6r_1)).f46(listOf((new (Builder_0())(Companion_getInstance_0().i6g_1)).q46(new (CompiledVariable())('input')).v39())).v39());
      }
    }
    initMetadataForObject($, 'SaveSlackIntegrationMutationSelections');
    SaveSlackIntegrationMutationSelectionsClass = $;
  }
  return SaveSlackIntegrationMutationSelectionsClass;
}
var SaveSlackIntegrationMutationSelections_instance;
function SaveSlackIntegrationMutationSelections_getInstance() {
  if (SaveSlackIntegrationMutationSelections_instance === VOID)
    new (SaveSlackIntegrationMutationSelections())();
  return SaveSlackIntegrationMutationSelections_instance;
}
//region block: exports
export {
  SaveSlackIntegrationMutationSelections_getInstance as SaveSlackIntegrationMutationSelections_getInstance126fzsxxh634k,
};
//endregion

//# sourceMappingURL=SaveSlackIntegrationMutationSelections.mjs.map
